.field {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
}

.label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-muted);
}

.control {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.input {
  flex: 1;
  min-width: 0;
  min-height: var(--hit-target);
  padding: 0 var(--spacing-md);
  border: 1px solid var(--color-border-strong);
  border-radius: var(--radius-md);
  background: var(--color-surface);
  color: var(--color-text);
}

.input:disabled {
  background: var(--color-surface-sunken);
  color: var(--color-text-disabled);
}

.unit {
  color: var(--color-text-muted);
  font-size: var(--font-size-sm);
}

/* ---- Toggle (switch) ---------------------------------------------------- */

.toggle {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-md);
  min-height: var(--hit-target);
  cursor: pointer;
}

.toggleInput {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}

.track {
  position: relative;
  flex: none;
  width: 46px;
  height: 26px;
  border-radius: 999px;
  background: var(--color-border-strong);
  transition: background-color var(--transition-fast);
}

.thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--color-surface);
  box-shadow: var(--shadow-sm);
  transition: transform var(--transition-fast);
}

.toggleInput:checked + .track {
  background: var(--color-primary);
}

.toggleInput:checked + .track .thumb {
  transform: translateX(20px);
}

.toggleInput:focus-visible + .track {
  outline: var(--focus-ring-width) solid var(--color-focus);
  outline-offset: 2px;
}

.toggleInput:disabled + .track {
  opacity: 0.5;
}
